const RightBarInitialState = {
  toggleState: 0,
};
export default RightBarInitialState;
